<app-payment-panel-paygreen-generic type="PAYGREEN_RESTOFLASH"></app-payment-panel-paygreen-generic>
